import elmntIO from './inc/elmnt-io.js';

export function tableOfContents() {
    const $comps = document.querySelectorAll('.component--toc-content');
    const tocClickScroll = new WeakMap();
    const tocDesktopMq = window.matchMedia('(min-width: 900px)');

    $comps?.forEach($comp => {
        initSingleToc($comp)
    });

    tocDesktopMq.addEventListener('change', () => {
        $comps.forEach($comp => animateTocNavActive($comp));
    });



    function initSingleToc($comp) {
        const $tocLinks = $comp.querySelectorAll('.toc-nav__link');
        const $tocSections = $comp.querySelectorAll('.toc-section');

        $tocLinks?.forEach($link => {
            $link.addEventListener('click', handleTocLinkClick);
        });

        $tocSections?.forEach($section => {
            $section.setAttribute('data-io', '');
            $section.setAttribute('data-io-threshold', '0');
            $section.setAttribute('data-io-margin', '-50% 0% -50% 0%');

            
            elmntIO($section, handleSectionEnter)
        });

        animateTocNavActive($comp);
    }

    function handleTocLinkClick(e) {
        e.preventDefault();
        const $link = e.currentTarget;
        const $targetSection = document.getElementById($link.getAttribute('href').replace('#', ''));
        const $comp = $link.closest('.component--toc-content');
        const $thisTocItems = $comp.querySelectorAll('.toc-nav__item');

        if (!$targetSection) return;

        tocClickScroll.set($comp, true);
        const clearTocClickScroll = () => tocClickScroll.delete($comp);
        window.addEventListener('scrollend', clearTocClickScroll, { once: true });
        window.setTimeout(clearTocClickScroll, 2000);

        $thisTocItems?.forEach($item => {
            $item.classList.remove('active');
        });
        $link.closest('.toc-nav__item')?.classList.add('active');
        animateTocNavActive($comp);

        const sectionTop = $targetSection.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: sectionTop - (window.innerHeight * 0.2),
            behavior: 'smooth',
        });
    }

    function handleSectionEnter(entry) {
        const $thisSection = entry.target;
        const $thisComp = $thisSection.closest('.component--toc-content');
        const $thisTocLinks = $thisComp.querySelectorAll('.toc-nav__link');

        if (tocClickScroll.has($thisComp)) return;

        $thisTocLinks?.forEach($link => {
            $link.closest('li').classList.remove('active');

            if ($link.getAttribute('href') === `#${$thisSection.id}`) {
                $link.closest('li').classList.add('active');
            }
        });

        animateTocNavActive($thisComp);
    }

    function animateTocNavActive($comp) {
        const $wrap = $comp.querySelector('.toc-nav__list-wrap');
        const $activeItem = $wrap?.querySelector('.toc-nav__item.active');
        if (!$wrap || !$activeItem) return;

        if (tocDesktopMq.matches) {
            const $indicator = $wrap.querySelector('.toc-nav__indicator');
            if (!$indicator) return;

            const wrapTop = $wrap.getBoundingClientRect().top;
            const itemRect = $activeItem.getBoundingClientRect();
            const y = itemRect.top - wrapTop + (itemRect.height / 2) - ($indicator.offsetHeight / 2);

            $indicator.style.transform = `translateY(${y}px)`;
            $indicator.classList.add('is-ready');
            return;
        }

        const wrapLeft = $wrap.getBoundingClientRect().left;
        const itemLeft = $activeItem.getBoundingClientRect().left;
        $wrap.scrollTo({
            left: $wrap.scrollLeft + (itemLeft - wrapLeft),
            behavior: 'smooth',
        });
    }
}